const landslide_config_store = {
    subscribers:{},
    options:{
        active: false,
        tooltipOptions: {show:false},
        filterOptions:{
            legends:{'no_data': true,  'ok': true, 'attention':true}
        }
    },
    setOption(option, value){
        this.options[option] = value
        this.publish('SET_OPTION', {option: option, value:value})
    },
    getFilterOption(option){
        return this.options.filterOptions[option]
    },
    setFilterOption(option, value){
        this.options.filterOptions[option] = value
        this.publish('SET_FILTER_OPTION', {option: option, value:value})
    },
    getOption(option){
        return this.options[option]
    },
    subscribe(topic, callback){
        if(!this.subscribers[topic]){
            this.subscribers[topic] = []
        }
        this.subscribers[topic].push(callback)
    },
    publish(topic, data){
        if(this.subscribers[topic]){
            this.subscribers[topic].forEach(callback => {
                callback(data);
            });
        }
    }
}

export default landslide_config_store